import Text from '../Typography/Text';
import { media } from '../../styles/media';
import styled from 'styled-components';

export const WrapperAudioPlayer = styled.div`
  margin: 0 0 ${props => props.theme.layout.gutter * 2}px;

  ${media.tablet`
  margin: 0 58px ${props => props.theme.layout.gutter * 2}px;
  `};
`;

export const TitleContent = styled.div`
  margin-bottom: 10px;
`;

export const ImageWrapper = styled.div`
  position: relative;
`;

export const CenturyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;

  position: absolute;
  width: 70px;
  height: 81px;
  right: 20px;
  bottom: 0px;

  background: #05425e;
  border-radius: 40px 40px 0px 0px;
`;

export const Century = styled.p`
  height: 31px;

  font-family: 'Francoeur';
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 140%;
  /* identical to box height, or 31px */

  /* Primary/White */

  color: #ffffff;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
`;

export const CenturyLabel = styled.p`
  height: 15px;

  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 800;
  font-size: 11px;
  line-height: 140%;
  text-transform: uppercase;
  color: #ffffff;
  flex: none;
  order: 1;
  flex-grow: 0;
`;
